import { AbstractParser } from "../parser";
import { ResponseError } from "src/app/ui/models/domains/pbm/response-error";

export class ResponseErrorParser extends AbstractParser<ResponseError> {
  parse(payload: any): ResponseError {
    const reponseError = new ResponseError();
    reponseError.setErrorCode(payload.error.Data.ErrorCode);
    reponseError.setErrorMessage(payload.error.Data.ErrorMessage);
    return reponseError;
  }
}
